import { render, staticRenderFns } from "./EventRaces.vue?vue&type=template&id=f196a97c&scoped=true&"
import script from "./EventRaces.vue?vue&type=script&lang=js&"
export * from "./EventRaces.vue?vue&type=script&lang=js&"
import style0 from "./EventRaces.vue?vue&type=style&index=0&id=f196a97c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f196a97c",
  null
  
)

export default component.exports